import ReactDOM from "react-dom";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import App from "./App";
import RxNotification from "./components/RxNotification";
import "./config/colors.css";
import "./index.css";
import { store } from "./redux/store";
import {
	checkLocalStorageTokens,
	removeTokens,
	setApiAuthHeader,
} from "./utils/AuthFunctions";

function render() {
	if (checkLocalStorageTokens()) {
		setApiAuthHeader();
	} else {
		removeTokens();
	}

	ReactDOM.render(
		<Provider store={store}>
			<ReactNotifications />
			<RxNotification />
			<HashRouter>
				<App />
			</HashRouter>
		</Provider>,
		document.getElementById("root")
	);
}

render();
